import Alodokter from "../utils/Alodokter";
import General from "../utils/General";

export default class WebinarAnalytics {
    static viewItemList(data, isImpression) {
        const dataItem = data.map((item) => {
            return {
                item_id: item.id,
                item_name: item.webinar_content.title,
                item_category: item.webinar_content.type == "series" ? "event" : "webinar",
                item_category2: item.webinar_content.is_paid_webinar ? "paid" : "free",
                price: item.webinar_content.payment_info ? General.getNumber(item.webinar_content.payment_info.normal_price) : 0,
                index: item.index + 1
            }
        })
        Alodokter.sendEventGA4({
            ecommerce: {
                items: dataItem,
                item_list_name: isImpression ? "webinar_visible" : "webinar",
            },
            event: "view_item_list",
        });
    }
    
    static selectItem(data, trigger) {
        Alodokter.sendEventGA4({
            ecommerce: {
                items: [
                    {
                        item_id: data.id,
                        item_name: data.webinar_content.title,
                        price: data.webinar_content.payment_info ? General.getNumber(data.webinar_content.payment_info.normal_price) : 0,
                        item_category: data.webinar_content.type == "series" ? "event" : "webinar",
                        item_category2: data.webinar_content.is_paid_webinar ? "paid" : "free",  
                    }
                ],
            },
            registration_status: data.webinar_content.is_registered,
            trigger: trigger,
            event: "select_item",
        });
    }

    static viewItem(data) {
        Alodokter.sendEventGA4({
            ecommerce: {
                items: [
                    {
                        item_id: data.id,
                        item_name: data.title,
                        price: data.is_paid_webinar ? General.getNumber(data.payment_info.normal_price) : 0,
                        item_category: data.type === "single" ? "webinar" : "event",
                        item_category2: data.is_paid_webinar ? "paid" : "free",
                    }
                ],
            },
            registration_status: data.is_registered,
            event: "view_item",
        })
    }

    static addToCart(data, entry_point) {
        Alodokter.sendEventGA4({
            ecommerce: {
                items: [
                    {
                        item_id: data.id,
                        item_name: data.title,
                        price: data.is_paid_webinar ? General.getNumber(data.payment_info.normal_price) : 0,
                        item_category: data.type === "single" ? "webinar" : "event",
                        item_category2: data.is_paid_webinar ? "paid" : "free",
                    }
                ],
                currency: "IDR",
                value: data.is_paid_webinar ? General.getNumber(data.payment_info.normal_price) : 0,
            },
            skp_type: "skp",
            entry_point: entry_point,
            event: "add_to_cart",
        })
    }

    static selectEventChild(data) {
        const tracker = {
            item_id: data.webinar_data.id,
            parent_id: data.event_data.id,
            item_name: data.webinar_data.title,
            registration_status: data.event_data.userRegisterStatusBool,
            event: "select_event_child",
        }
        Alodokter.sendEventGA4(tracker);
    }
    
    static startTest(data){
        const tracker = {
            item_id: data.id,
            item_name: data.title,
            skp_type: 'skp',
            event: "start_test"
        };
        Alodokter.sendEventGA4(tracker);
    }

    static finishTest(skpId, data){
        const tracker = {
            item_id: skpId,
            item_name: data.skp.title,
            skp_type: data.skp.type_of,
            test_result: data.status == "pass" ? "passed" : "failed",
            event: "finish_test"
        };
        Alodokter.sendEventGA4(tracker);
    }

    static viewSkp(data){
        const tracker = {
            item_id: data.id,
            item_name: data.title,
            skp_type: data.type_of,
            progress_status: data.status == 0 ? "not_started" : data.status == 1 ? "failed" : "passed",
            event: "view_skp",
        };
        Alodokter.sendEventGA4(tracker);
    }

    static viewWebinarHistory(data, isFromCard){
        let tracker = {
            item_id: data.id,
            item_name: data.title,
            item_category: data.type == "series" ? "event" : "webinar",
            item_category2: data.is_paid_webinar ? "paid" : "free",
            registration_status: data.is_registered,
            transaction_status: data.webinar_registration_status,
            trigger: isFromCard ? "card_area" : "cta",
            entry_point: "webinar_activity",
            event: "view_history",
        };

        if (data.payment_info) {
            tracker.transaction_id = data.payment_info.transaction_id;
        }
        Alodokter.sendEventGA4(tracker);
    }
}
